import type { TimeseriesDataSet } from '../../../../DataProvider/types';
import type { DataConverter, SheetData } from '../types';
import { formatColumnName } from './utils';

/**
 * Convert TimeseriesDataSet to sheet format
 * Used for line charts and time-based visualizations
 */
export const convertTimeseriesDataToSheet: DataConverter<TimeseriesDataSet> = ({
  data,
}): SheetData[] => {
  const allDates = Array.from(
    new Set(
      data.data.flatMap((series) =>
        series.timeseries.map((point) => point.date.split('T')[0])
      )
    )
  ).sort();

  const seriesMap = new Map(
    data.data.map((series) => [
      series.dim,
      new Map(
        series.timeseries.map((point) => [
          point.date.split('T')[0],
          point.value,
        ])
      ),
    ])
  );

  return allDates.map((date) => ({
    Date: date ?? '',
    ...Object.fromEntries(
      data.data.map((series) => [
        formatColumnName(series.dim),
        seriesMap.get(series.dim)?.get(date) ?? null,
      ])
    ),
  }));
};
